import type { IStorageProvider } from '@unleash/proxy-client-react';

export default class SessionStorageProvider implements IStorageProvider {
  private prefix = 'unleash:repository';

  // oxlint-disable-next-line @typescript-eslint/require-await
  public async save(name: string, data: unknown) {
    const repo = JSON.stringify(data);
    const key = `${this.prefix}:${name}`;
    try {
      window.sessionStorage.setItem(key, repo);
    } catch (ex) {
      // oxlint-disable-next-line no-console
      console.error(ex);
    }
  }

  public get(name: string) {
    try {
      const key = `${this.prefix}:${name}`;
      const data = window.sessionStorage.getItem(key);
      const result = data ? JSON.parse(data) : undefined;

      return Promise.resolve(result);
    } catch (e) {
      // tslint:disable-next-line
      // oxlint-disable-next-line no-console
      console.error(e);
      return Promise.resolve(undefined);
    }
  }
}
